import { css } from '@emotion/react'
import { theme } from '@app/styles/theme'

export const containerStyles = css`
  background: ${theme.palette.secondary.contrastText};
  border: 1px solid ${theme.palette.neutral.dark};
  border-radius: 8px;
  padding: 0;
  margin-bottom: ${theme.spacing(4)};
`

export const headerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(2)};
`

export const headerLabelStyles = css`
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${theme.palette.neutral[700]};
`

export const toggleButtonStyles = css`
  min-width: auto;
  border: 1px solid ${theme.palette.neutral.dark};
  border-radius: 8px;
  background: ${theme.palette.neutral.light};
  color: ${theme.palette.black.main};
  font-size: 12px;
  font-weight: 500;
  text-transform: none;

  &:hover {
    background: ${theme.palette.white.dark};
    border-color: ${theme.palette.neutral[400]};
  }
`

export const activeCountStyles = css`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: ${theme.palette.secondary[200]};
  color: ${theme.palette.primary.dark};
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const activeCountStylesContainer = css`
  display: flex;
  align-items: center;
  gap: 1px;
`

export const bodyStyles = css`
  padding: ${theme.spacing(2.5)} ${theme.spacing(4)} ${theme.spacing(4)};
  display: grid;
  gap: ${theme.spacing(4)};
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const filterGroupStyles = css`
  min-width: 0;
`

export const filterLabelStyles = css`
  margin-bottom: ${theme.spacing(2)};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${theme.palette.neutral[700]};
`

export const chipsRowStyles = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(2)};
`

export const optionChipStyles = (active: boolean) => css`
  height: 28px;
  border-radius: 6px;
  border: 1px solid ${active ? theme.palette.secondary[300] : theme.palette.neutral.dark};
  background: ${active ? theme.palette.secondary[100] : theme.palette.white.main};
  color: ${active ? theme.palette.primary.dark : theme.palette.neutral[800]};

  .MuiChip-label {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
  }

  &:hover {
    background: ${active ? theme.palette.secondary[200] : theme.palette.white.light};
  }
`

export const selectStyles = (active: boolean) => css`
  height: 28px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  color: ${active ? theme.palette.primary.dark : theme.palette.neutral[800]};
  background: ${active ? theme.palette.secondary[100] : theme.palette.white.main};

  .MuiOutlinedInput-notchedOutline {
    border-color: ${active ? theme.palette.secondary[300] : theme.palette.neutral.dark};
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${active ? theme.palette.secondary[300] : theme.palette.neutral[400]};
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.palette.secondary[300]};
    border-width: 1px;
  }

  .MuiSelect-select {
    padding-left: 10px;
    padding-right: 28px;
    line-height: 1;
  }
`

export const selectMenuItemStyles = css`
  font-size: 12px;
  font-weight: 400;
  color: ${theme.palette.neutral[800]};
  padding: ${theme.spacing(1.5)} ${theme.spacing(3)};

  &.Mui-selected {
    background: ${theme.palette.secondary[100]};
    color: ${theme.palette.primary.dark};

    &:hover {
      background: ${theme.palette.secondary[200]};
    }
  }

  &:hover {
    background: ${theme.palette.white.light};
  }
`

export const footerRowStyles = css`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  padding-top: ${theme.spacing(1)};
`

export const resetButtonStyles = css`
  text-transform: none;
  color: ${theme.palette.black[400]};
  font-size: 13px;
  font-weight: 500;

  &:hover {
    background: transparent;
    color: ${theme.palette.black.main};
  }
`
